// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"6d3b41cd","276":"457c66e2","416":"5bd25d94","578":"028b73a1","623":"65cd2126","695":"ee350030","788":"9a8c60dc","791":"f3c0e0ab"}[chunkId] + ".chunk.js";
};